import { Routes } from "@angular/router";
import { CreateHeaderQuoteComponent } from "./components/create-header-quote/create-header-quote.component";
import { CreateLineQuoteComponent } from "./components/create-line-quote/create-line-quote.component";
import { PoEmailQuoteComponent } from "./components/po-email-quote/po-email-quote.component";
import { QuoteSummaryComponent } from "./components/quote-summary/quote-summary.component";
import { QuotesListingComponent } from "./components/quotes-listing/quotes-listing.component";

export const proposalRoutes: Routes = [
  { path: "", component: QuotesListingComponent },
  { path: "add-header", component: CreateHeaderQuoteComponent },
  { path: "add-line/:id", component: CreateLineQuoteComponent },
  { path: "quote-summary/:id", component: QuoteSummaryComponent },
  {
    path: "add-line/:id/:linenumber",
    component: CreateLineQuoteComponent,
  },
  {
    path: "po-email/:id",
    component: PoEmailQuoteComponent,
  },
];
